import styled from 'styled-components'

import { TypeStyle } from '@syconium/little-miss-figgy'

import { Label, SelectedOptionText } from '../../../primitives/shared-form-styles'

/** The form below the placement picker. The divider is what the designs separate sections with. */
export const EditorSection = styled.div`
  border-top: 1px solid ${o => o.theme.color.stroke.neutral.border.decoration.on.background};
  display: flex;
  flex-direction: column;
  gap: ${o => o.theme.spacing(5)};
  padding-top: ${o => o.theme.spacing(5)};
`

export const SummaryHeader = styled(Label)`
  align-items: center;
  display: flex;
  gap: ${o => o.theme.spacing(2)};
  margin-bottom: ${o => o.theme.spacing(3)};
`

export const SummaryLogoName = styled(SelectedOptionText)`
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

/** Pushes the colour and its price to the far end of the heading row. */
export const SummaryPrice = styled.span`
  ${TypeStyle.css.headlineMicro}
  align-items: center;
  display: flex;
  gap: ${o => o.theme.spacing(1)};
  margin-left: auto;
  text-transform: none;
`

export const FinalSaleNotice = styled(TypeStyle.BodyNano)`
  background-color: ${o => o.theme.color.fill.subtle};
  border-radius: ${o => o.theme.borderRadius.sm};
  display: flex;
  gap: ${o => o.theme.spacing(3)};
  line-height: 20px;
  padding: ${o => o.theme.spacing(3, 4)};
`
